export const ApplicationModules = {
  HRMS: 'hrms',
};
export const configKeys = [
  'db_connection_string',
  'token_secret_key',
  'email_configuration',
];
